<script lang="ts">
  import { onMount } from 'svelte'
  import { Pages } from '@packages/utils/enums'
  import { pageOptsStore, fn, pageStore, userStore, clientPublicStore } from '@packages/stores'
  import { dispatch, PassportEvents } from '@lib/events/events'
  import { CredenzaBalance } from '@packages/ui'
  import { get } from 'svelte/store'
  import { analytics } from '@lib/mixpanel/mixpanel'
  import { configStore } from '@src/stores/config'
  import { buyWithCred, getAddress, getBalance } from '@src/passport/blockchain'
  import { waitVideoEnded } from '@components/progress/ProgressVideo.service'
  import { requestSuiReceipt } from '../Payment.service'

  export let totalPriceToken: number
  export let purchaseConfig: {
    assets: { type: string; packageId: string; assetId?: number; amount?: number }[]
    title: string
    subtitle: string
  }
  export let isLoading: boolean
  export let isPriceLoading: boolean
  export let pricesByAsset: number[] = []

  const { toastAlert } = get(fn)
  const config = get(configStore)

  let balance = 0

  const processPaymentTx = async (
    asset: { type: string; packageId: string; assetId?: number; amount?: number },
    index: number,
  ) => {
    const { type, packageId, assetId, amount } = asset
    const paymentRes = await buyWithCred(type, packageId, { assetId, amount })
    const { title, subtitle } = purchaseConfig
    dispatch(PassportEvents.PAYMENT)
    dispatch(PassportEvents.RECHECK_BALANCE)
    await requestSuiReceipt({
      digest: paymentRes.digest,
      title,
      subtitle,
      amount: pricesByAsset[index],
      currency: 'CRED',
    })
    dispatch(PassportEvents.RECEIPT, { digest: paymentRes.digest })
  }

  const payWithCredenza = async () => {
    try {
      if (BigInt(totalPriceToken) > balance) return

      isLoading = true
      const { assets } = purchaseConfig

      for (const [index, asset] of assets.entries()) {
        await processPaymentTx(asset, index)

        await new Promise((resolve) => setTimeout(resolve, 1000))
      }

      const user = get(userStore)
      if (user) {
        analytics.track('cp_payment_stored_value', {
          $email: user.email,
          $phone: user.phone,
          suiNetwork: config.suiNetwork,
          clientId: config.clientId,
          location: window.location.href,
          address: await getAddress(),
          assets,
          total: totalPriceToken,
          description: (purchaseConfig?.title ?? '') + `(${purchaseConfig?.subtitle ?? ''})`,
        })
      }
      await waitVideoEnded()

      pageStore.set(Pages.PAYMENT_RESULT)
    } catch (err) {
      toastAlert(`Payment error: ${err.message || err}`, 'failure')
      pageOptsStore.set({ errorMessage: err.message })
      pageStore.set(Pages.ERROR)
      dispatch(PassportEvents.ERROR, { error: err })
    } finally {
      isLoading = false
    }
  }

  onMount(async () => {
    balance = Number(await getBalance())
  })

  $: formattedBalance = `${(balance - totalPriceToken).toFixed(2)}`
</script>

<CredenzaBalance
  options={{
    formattedBalance,
    balance,
    credAlias:$clientPublicStore.ui_settings.cred_alias,
    onPay: payWithCredenza,
    onGetCred: () => pageStore.set(Pages.WALLET),
    totalToPay: String(totalPriceToken),
    isLoading,
    isPaymentDisabled: !Number(balance) || totalPriceToken > balance || isPriceLoading,
  }}
/>
